import React from 'react';

export default function ChevronDown({ className }) {
  return (
    <svg className={className} viewBox='0 0 33.02 21.02'>
      <g id='Right'>
        <path d='M16.51,10.15L7.68,1.32C6.83,.47,5.7,0,4.5,0S2.17,.47,1.32,1.32C.47,2.17,0,3.3,0,4.5s.47,2.33,1.32,3.18l12,12.02c.86,.85,2,1.32,3.18,1.32,1.21,0,2.35-.46,3.22-1.33,.06-.06,.12-.13,.18-.2L31.7,7.68c.88-.88,1.31-2.03,1.31-3.18s-.44-2.3-1.32-3.18C30.85,.47,29.72,0,28.52,0s-2.33,.47-3.18,1.32l-8.83,8.83Z' />
      </g>
    </svg>
  );
}
